import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoints } from '@styles/index';
import Container, { StyledButton, Caption, Title, Description } from './styles';
import Benifits from './Benifits';

const StyledContainer = styled(Container)`
  margin-bottom: 96px;
  @media (max-width: ${breakpoints.tablet}) {
    margin-bottom: 0;
    place-items: baseline;
  }
`;
const BackgroundColor = styled.div`
  background: #fcfcfc;
  padding-top: 120px;
  padding-bottom: 120px;
  @media (max-width: ${breakpoints.tablet}) {
    padding-top: 80px;
    padding-bottom: 80px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    padding: 0 16px;
  }
`;

const LeftSection = styled.section`
  grid-column: span 7;
  padding-top: 47px;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: span 24;
    padding-top: 0;
  }
  @media (max-width: ${breakpoints.mobile}) {
    padding-top: 56px;
  }
`;

const HighLightText = styled.span`
  color: #08bd80;
`;

const RightSection = styled.img`
  grid-column: 9/25;
  object-fit: cover;
  height: 450px;
  cursor: pointer;
  user-drag: none;
  user-select: none;
  @media (max-width: ${breakpoints.tablet}) {
    grid-column: span 24;
    margin-top: 40px;
  }
  @media (max-width: ${breakpoints.mobile}) {
    height: 196px;
    margin-top: 8px;
  }
`;

function Understand({
  // handleLeadgenOpen,
  scrollToForm,
  understandRef,
  data,
  benifitsTitle
}) {
  const {
    caption,
    title,
    subTitle,
    description,
    buttonText,
    resource,
    image
  } = data;
  return (
    <BackgroundColor ref={understandRef}>
      <StyledContainer>
        <LeftSection>
          <Caption>{caption}</Caption>
          <Title>
            <HighLightText>{`${title} `}</HighLightText>
            {subTitle}
          </Title>
          <Description>{description}</Description>
          <StyledButton $hideSm onClick={scrollToForm}>
            {buttonText}
          </StyledButton>
        </LeftSection>
        <RightSection
          src={image}
          alt="understand"
          height="auto"
          width="100%"
          loading="lazy"
        />
      </StyledContainer>
      <Benifits
        benifitsTitle={benifitsTitle}
        title={buttonText}
        benifits={resource}
        handleClick={scrollToForm}
      />
    </BackgroundColor>
  );
}

Understand.propTypes = {
  // handleLeadgenOpen: PropTypes.func,
  scrollToForm: PropTypes.func.isRequired,
  understandRef: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  benifitsTitle: PropTypes.string
};
Understand.defaultProps = {
  benifitsTitle: ''
  // handleLeadgenOpen: () => {}
};

export default Understand;
